// extracted by mini-css-extract-plugin
export default {"user-table__action":"User_user-table__action__cRaBM"};